import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {TreeLazyComponent} from '@Common/widgets/general/tree-lazy/tree-lazy.component';
import {constantes} from '../../common/constantes';
import {entiteTypeEnum} from '../../common/enum/entite-type.enum';

@Component({
  selector: 'app-entites',
  templateUrl: './entites.component.html',
  styleUrls: ['./entites.component.scss']
})
export class EntitesComponent implements OnInit, OnDestroy {

  entiteTypeEnum = entiteTypeEnum;
  entityChoice = this.entiteTypeEnum.dir; //default choice
  constantes = constantes;

  constructor() { }

  ngOnInit(): void {

  }

  public setChoice(entiteType: number): void {
    this.entityChoice = entiteType;
  }

  ngOnDestroy(): void { }
}
